'use client';
import { createTheme, type ThemeOptions } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import tailwindTheme from './../../tailwind.config';

const colors = tailwindTheme.theme.extend.colors;

export const shadows = tailwindTheme.theme.extend.boxShadow;

export const COLORS = {
  white: { main: colors.white, contrastText: colors.black },
  black: { main: colors.black, contrastText: colors.white },
  'site-background': { main: colors['site-background'] },
  'dialog-backdrop': { main: colors['dialog-backdrop'] },
  'brand.blue': { main: colors.brand.blue, contrastText: '#fff' },
  'brand.orange': { main: colors.brand.orange, contrastText: '#fff' },
  'brand.accent': { main: colors.brand.accent, contrastText: '#fff' },
  'blue-1': { main: colors.blue[1], contrastText: '#fff' },
  'blue-2': { main: colors.blue[2], contrastText: '#fff' },
  'blue-3': { main: colors.blue[3], contrastText: '#fff' },
  'blue-4': { main: colors.blue[4], contrastText: '#fff' },
  'cyan-1': { main: colors.cyan[1], contrastText: '#fff' },
  'cyan-2': { main: colors.cyan[2], contrastText: '#fff' },
  'cyan-3': { main: colors.cyan[3], contrastText: '#fff' },
  'cyan-4': { main: colors.cyan[4], contrastText: '#fff' },
  'emerald-1': { main: colors.emerald[1], contrastText: '#fff' },
  'emerald-2': { main: colors.emerald[2], contrastText: '#fff' },
  'emerald-3': { main: colors.emerald[3], contrastText: '#fff' },
  'emerald-4': { main: colors.emerald[4], contrastText: '#fff' },
  'green-1': { main: colors.green[1], contrastText: '#fff' },
  'green-2': { main: colors.green[2], contrastText: '#fff' },
  'green-3': { main: colors.green[3], contrastText: '#fff' },
  'green-4': { main: colors.green[4], contrastText: '#fff' },
  'lime-1': { main: colors.lime[1], contrastText: '#fff' },
  'lime-2': { main: colors.lime[2], contrastText: '#fff' },
  'lime-3': { main: colors.lime[3], contrastText: '#fff' },
  'lime-4': { main: colors.lime[4], contrastText: '#fff' },
  'navy-1': { main: colors.navy[1], contrastText: '#fff' },
  'navy-2': { main: colors.navy[2], contrastText: '#fff' },
  'navy-3': { main: colors.navy[3], contrastText: '#fff' },
  'navy-4': { main: colors.navy[4], contrastText: '#fff' },
  'orange-1': { main: colors.orange[1], contrastText: '#fff' },
  'orange-2': { main: colors.orange[2], contrastText: '#fff' },
  'orange-3': { main: colors.orange[3], contrastText: '#fff' },
  'orange-4': { main: colors.orange[4], contrastText: '#fff' },
  'pink-1': { main: colors.pink[1], contrastText: '#fff' },
  'pink-2': { main: colors.pink[2], contrastText: '#fff' },
  'pink-3': { main: colors.pink[3], contrastText: '#fff' },
  'pink-4': { main: colors.pink[4], contrastText: '#fff' },
  'purple-1': { main: colors.purple[1], contrastText: '#fff' },
  'purple-2': { main: colors.purple[2], contrastText: '#fff' },
  'purple-3': { main: colors.purple[3], contrastText: '#fff' },
  'purple-4': { main: colors.purple[4], contrastText: '#fff' },
  'red-1': { main: colors.red[1], contrastText: '#fff' },
  'red-2': { main: colors.red[2], contrastText: '#fff' },
  'red-3': { main: colors.red[3], contrastText: '#fff' },
  'red-4': { main: colors.red[4], contrastText: '#fff' },
  'yellow-1': { main: colors.yellow[1], contrastText: '#fff' },
  'yellow-2': { main: colors.yellow[2], contrastText: '#fff' },
  'yellow-3': { main: colors.yellow[3], contrastText: '#fff' },
  'yellow-4': { main: colors.yellow[4], contrastText: '#fff' },
  'grey-1': { main: colors.grey[1], contrastText: '#fff' },
  'grey-2': { main: colors.grey[2], contrastText: '#fff' },
  'grey-3': { main: colors.grey[3], contrastText: '#fff' },
  'grey-4': { main: colors.grey[4], contrastText: '#fff' },
  'grey-5': { main: colors.grey[5], contrastText: '#fff' },
  'grey-6': { main: colors.grey[6], contrastText: '#fff' },
  'grey-7': { main: colors.grey[7], contrastText: '#fff' },
  'grey-8': { main: colors.grey[8], contrastText: '#fff' },
  'grey-9': { main: colors.grey[9], contrastText: '#fff' },
  // Aurora warm/cool inks (light = taupe, dark = mauve)
  'taupe-1': { main: colors.taupe[1], contrastText: '#fff' },
  'taupe-2': { main: colors.taupe[2], contrastText: '#fff' },
  'taupe-3': { main: colors.taupe[3], contrastText: '#fff' },
  'mauve-1': { main: colors.mauve[1], contrastText: colors.taupe[3] },
  'mauve-2': { main: colors.mauve[2], contrastText: colors.taupe[3] },
  'mauve-3': { main: colors.mauve[3], contrastText: '#fff' },
  // Default MUI greys:
  'grey-50': { main: grey[50], contrastText: '#fff' },
  'grey-100': { main: grey[100], contrastText: '#fff' },
  'grey-200': { main: grey[200], contrastText: '#fff' },
  'grey-300': { main: grey[300], contrastText: '#fff' },
  'grey-400': { main: grey[400], contrastText: '#fff' },
  'grey-500': { main: grey[500], contrastText: '#fff' },
  'grey-600': { main: grey[600], contrastText: '#fff' },
  'grey-700': { main: grey[700], contrastText: '#fff' },
  'grey-800': { main: grey[800], contrastText: '#fff' },
  'grey-900': { main: grey[900], contrastText: '#fff' },
  'grey-A100': { main: grey['A100'], contrastText: '#fff' },
  'grey-A200': { main: grey['A200'], contrastText: '#fff' },
  'grey-A400': { main: grey['A400'], contrastText: '#fff' },
  'grey-A700': { main: grey['A700'], contrastText: '#fff' },
};

const SHAPES = {
  rounded: tailwindTheme.theme.extend.borderRadius,
};

const themeOptions: ThemeOptions = {
  palette: COLORS,
  // @ts-ignore
  shape: SHAPES,
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiSelect: {
      defaultProps: {
        sx: {
          '& .MuiInputBase-input': {
            color: 'text.primary',
          },
          '& .Mui-disabled, & .MuiInputBase-input.Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiList: {
      defaultProps: {
        sx: {
          '&': {
            outline: 'none',
          },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        // @ts-ignore
        color: 'brand.accent',
        sx: {
          '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
            transition: 'border-color 0.2s',
          },
          '& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline':
            {
              borderColor: COLORS['brand.accent'].main,
            },
          '& .MuiInputBase-input': {
            color: 'text.primary',
          },
          '& .MuiInputBase-root': {
            // borderRadius: '6px',
            borderRadius: SHAPES.rounded['3xl'],
          },
          '& .MuiFormLabel-root:not(.Mui-focused)': {
            color: 'text.primary',
            fontSize: '0.9rem',
            lineHeight: '1.5rem',
          },
          '& .Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
        color: 'brand.accent',
        sx: {
          '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
            transition: 'border-color 0.2s',
            // borderColor: COLORS.grey[300],
          },
          '& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline':
            {
              borderColor: COLORS['brand.accent'].main,
            },
          '& .MuiInputBase-input, & .MuiFormLabel-root:not(.Mui-focused)': {
            color: 'text.primary',
          },
          '& .MuiInputBase-root': {
            borderRadius: SHAPES.rounded['2xl'],
          },
          '& .Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiFilledInput: {
      defaultProps: {
        sx: {
          '&': {
            overflow: 'hidden',
            paddingLeft: '0.25rem',
          },
          '&, &.Mui-focused': {
            backgroundColor: COLORS['grey-2'].main,
          },
          '&:hover': {
            backgroundColor: COLORS['grey-3'].main,
          },
          '& .MuiFilledInput-input': {
            paddingTop: '24px',
          },
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small',
        // @ts-ignore
        color: 'brand.accent',
        sx: {
          '&': {
            borderRadius: '6px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            transition: 'border-color 0.2s',
          },
          '&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
            borderColor: COLORS['brand.accent'].main,
          },
          '& .MuiInputBase-input': {
            color: 'text.primary',
          },
          '& .MuiFormLabel-root:not(.Mui-focused)': {
            color: 'text.primary',
          },
          '&.Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      'Fira Sans',
      'Droid Sans',
      'Helvetica Neue',
      'sans-serif',
    ].join(','),
  },
};

export const theme = createTheme(themeOptions);

// Minimal MUI dark companion: same palette/components, MUI dark mode so
// un-overridden MUI primitives (Paper, inputs, default text) render dark.
export const darkTheme = createTheme({
  ...themeOptions,
  palette: { ...COLORS, mode: 'dark' },
});
